<template>
  <div class="login">
    <h2>Log in</h2>
    <a :href="authUrl">Log in with Twitch</a>
    <!-- <form @submit.prevent="login">
      <input v-model="email" type="text" placeholder="Email" />
      <input v-model="password" type="password" placeholder="Password" />
      <button>Log In</button>
    </form> -->
    <div class="error" v-if="error" v-text="error"></div>
  </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'
import config from '../config'

export default {
  name: 'LogIn',

  data () {
    return {
      error: '',
      email: '',
      password: '',
      authUrl: `https://id.twitch.tv/oauth2/authorize?client_id=${config.twitch.clientId}&redirect_uri=${config.twitch.redirectUri}&response_type=token&scope=channel_subscriptions+channel_check_subscription+user_read+channel:read:subscriptions`
    }
  },

  methods: {
    login () {
      this.error = ''
      // firebase.auth()
      //   .signInWithEmailAndPassword(this.email, this.password)
      //   .then(() => this.$store.dispatch('login'))
      //   .catch((err) => this.error = err.toString())
      firebase.auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => this.$router.push('/'))
        .catch((err) => this.error = err.toString())
    }
  },

  beforeRouteEnter (to, from, next) {
    if (to.path === '/logout') {
      return firebase.auth()
        .signOut()
        .then(() => next('/login'))
    }

    next()
  },

  created () {
    if (window.location.hash) {
      try {
        const params = new URLSearchParams(window.location.hash.slice(1))
        const token = params.get('access_token')

        token && axios.post(`${config.api.url}/login`, { token })
          .then(async ({ data }) => {
            console.log({ data })
            const { user } = await firebase.auth().signInWithCustomToken(data.token)
            const [ profile ] = await axios
              .get('https://api.twitch.tv/helix/users', {
                headers: {
                  Authorization: `Bearer ${token}`
                }
              }).then(({ data }) => data.data)
            user.updateProfile({
              displayName: profile.display_name,
              photoURL: profile.profile_image_url
            })
          })
          // .then(({ user }) => user.getIdTokenResult())
          // .then(({ claims }) => store.commit('setUser', claims))
      } catch (err) {
        console.error('Could not parse token', err)
      }
    }
  }
}
</script>

<style scoped>
.error {
  color: red;
}
</style>
